import { render, staticRenderFns } from "./subcontractorSpecialty.vue?vue&type=template&id=39f95bdc&scoped=true&"
import script from "./subcontractorSpecialty.vue?vue&type=script&lang=js&"
export * from "./subcontractorSpecialty.vue?vue&type=script&lang=js&"
import style0 from "./subcontractorSpecialty.vue?vue&type=style&index=0&id=39f95bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f95bdc",
  null
  
)

export default component.exports